import classNames from 'classnames';
import { duplicateActionTypesArray } from '../../../../../../../consts/conditions';

import InfoIcon from '../../../../../../../assets/icons/info.svg?react';
import React from 'react';
import styled from 'styled-components';
import { Checkbox, Flex, Radio, rem, Text } from '@mantine/core';

export const RemoveDuplicates = ({
  item,
  columns,
  filterTypes,
  onToggleColumnItem,
  onClearColumns,
  onChangeKeep
}) => {
  const filterTypeId = filterTypes?.[0]?.id;
  const isCheckedAll = columns?.length > 0 && item?.columns?.length === columns?.length;

  const toggleAll = () => {
    if (isCheckedAll) {
      onClearColumns(filterTypeId, item?.id);
    } else {
      columns.forEach(col => {
        onToggleColumnItem(filterTypeId, item?.id, col, 'add');
      });
    }
  };

  const isKeepDisabled = !item?.keep;

  return (
    <div id="grid-table-remove-duplicates-root" className="">
      <div
        id="grid-table-remove-duplicates-card"
        className={classNames('filter_card', {
          ['noBorderBottom']: true,
          ['noBorderRight']: true
        })}
        style={{
          marginTop: '-10px',
          position: 'relative',
          zIndex: 16
        }}
      >
        <div
          id="grid-table-remove-duplicates-content"
          className="filter_content"
          style={{ width: '100%', minWidth: 200 }}
        >
          <div
            className="form-element"
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px'
            }}
          >
            <Text size={rem(14)} fw={600} mb={rem(16)}>
              If duplicates are found
            </Text>

            <Wrapper id="grid-table-remove-duplicates-wrapper">
              <Flex id="grid-table-remove-duplicates-options" align="center" gap="15px">
                {duplicateActionTypesArray.map((el, idx) => (
                  <RadioItem id={`grid-table-remove-duplicates-option-${idx}`} key={idx}>
                    <Radio
                      id={`grid-table-remove-duplicates-radio-${idx}`}
                      size="xs"
                      label={el.label}
                      fw={400}
                      checked={el.value === item.keep}
                      error={item.errors?.includes('keep')}
                      onClick={() => onChangeKeep(filterTypeId, item?.id, el.value)}
                    />

                    <InfoIcon data-tooltip-content={el.tooltip} data-tooltip-id="ligth-tooltip" />
                  </RadioItem>
                ))}
              </Flex>
            </Wrapper>
          </div>

          <div
            className="form-element"
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px'
            }}
          >
            <Flex
              id="grid-table-remove-duplicates-columns-header"
              align="center"
              justify="space-between"
              mt={rem(32)}
              mb={rem(16)}
            >
              {item.errors?.includes('columns') ? (
                <Text size={rem(14)} fw={600} c="red">
                  Select columns - Required
                </Text>
              ) : (
                <Text size={rem(14)} fw={600}>
                  Select columns <span className="required">*</span>
                </Text>
              )}
              <button
                id="grid-table-remove-duplicates-toggle-all"
                style={{
                  display: 'flex',
                  gap: '5px',
                  padding: 0,
                  width: 'fit-content'
                }}
                onClick={toggleAll}
              >
                <Checkbox
                  id="grid-table-remove-duplicates-toggle-all-checkbox"
                  name="columns"
                  checked={isCheckedAll}
                />

                <span
                  style={{
                    fontSize: '14px',
                    color: '#101113',
                    fontWeight: 400
                  }}
                >
                  {isCheckedAll ? 'Unselect All' : 'Select All'}
                </span>
              </button>
            </Flex>

            {columns?.map(col => (
              <button
                id={`grid-table-remove-duplicates-column-${col}`}
                key={col}
                style={{
                  display: 'flex',
                  gap: '5px',
                  padding: 0,
                  width: 'fit-content',
                  alignItems: 'center'
                }}
                data-testid={`checkbox-${col}-${item?.columns?.includes(col)}`}
                onClick={() => onToggleColumnItem(filterTypeId, item?.id, col)}
              >
                <Checkbox
                  id={`grid-table-remove-duplicates-column-checkbox-${col}`}
                  size={rem(20)}
                  value={col}
                  name="columns"
                  checked={item?.columns?.includes(col)}
                />

                <span
                  style={{
                    fontSize: '14px',
                    color: '#101113',
                    fontWeight: 400
                  }}
                >
                  {col}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const Wrapper = styled.div`
  display: flex;
`;

const RadioItem = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 4px;
  min-width: 140px;

  &:last-child {
    min-width: 170px;
  }

  span {
    display: flex;
    flex-wrap: nowrap;
    color: #101113;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
  }

  /* svg {
    min-width: 20px;
    min-height: 20px;
  } */
`;
